const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Gjer ditt valg",
  seeAll: "Se alle",
  clear: "Tøm",
  back: "Attende",
  save: "Lagra",
  close: "Lukk",
  of: "Av",
  to: "Til",
  copyrights: "© {date} Bridgestone Solutions. Alle rettar reservert.",
  pageNotFound: "Sida vart ikkje funne",
  accessDenied: "Tilgang nekta",
  search: "Søk",
  year: "År",
  buttons: {
    loading: "Laster...",
    export: "Eksporter",
    delete: "Slett",
    save: "Lagra",
    cancel: "Avbryt",
    next: "Neste",
    back: "Attende",
    skip: "Hopp over",
    send: "Send",
    clear: "Tøm",
    close: "Lukk",
    readNow: "Les nå",
    pointsList: "Punktliste",
    more: "Mer",
    reportError: "Rapporter feil",
    accept: "Godta",
    download: "Last ned",
    downloadAll: "Last ned alle",
    selectAll: "Vel alle",
    deselectAll: "Fjern val",
    downloadSelection: "Last ned valde",
    dealerInfoDownload: "LAST NED",
    toTheBasket: "Til handlevogna",
    toOrderDelivery: "Fortsett til leveringsadresse",
    discover: "Utforsk",
    newAddress: "Opprett ny leveringsadresse",
    selectAddressBtn: "Vel leveringsadresse",
    toOrderSummary: "Til ordreoversikt",
    placeOrder: "Bindende bestilling",
    toDashboard: "Til forsiden",
    newOrder: "Ny bestilling",
    userOrders: "Til dine bestillinger",
    toSearch: "Søk",
    select: "Velg",
    moreCustomerNumbers: "+ LEGG TIL FLERE KUNDENUMMERE",
    loadMore: "Last inn fleire",
    toStaffDashboard: "Til dashbord",
    toQuiz: "Til quiz",
    vouchers: "Kuponger",
    exchangeVoucher: "Løs inn kupongkode",
    confirm: "Bekreft",
    sharePoints: "Del poeng",
    create: "Opprett",
    update: "Oppdater",
    toBDrive: "B-Drive",
    preview: "Førehandsvising",
    clickHere: "Se detaljer",
    setFilters: "Vennlegst sett <b>maksimalt ett filter per kolonne</b>",
    all: "Alle",
  },
  tooltips: {
    info: "Trenger du hjelp? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Bekreftelse krevst",
    message: "Vil du slette denne oppføringa?",
  },
  nav: {
    dashboard: "Dashbord",
    accountDashboard: "Dashbord",
    account: "Profil",
    mailbox: "Innboks",
    singleMailbox: "Meldinger",
    stammdaten: "Stamdata",
    news_feeds: "Nyhetsstrømmer",
    pointsOverview: "Punktoversikt",
    rewardsOverview: "Punktoversikt",
    about: "Om BS Plus",
    service_number: "Kundeservice",
    shop: "Belønningsbutikk",
    salesPromotions: "Salgskampanjer",
    promotions: "Mi konto",
    shopCategory: "Belønningsbutikk",
    productDetails: "Produktdetaljer",
    userOrders: "Brukarbestillingar",
    shoppingCart: "Handlevogn",
    orderDelivery: "Leveringsadresse",
    orderSummary: "Ordreoversikt",
    orderComplete: "Bestilling fullført",
    text_page: "Statisk side",
    staff: "Servicedashbord",
    onlineTrainings: "Nettkurs",
    trainings: "Kurs",
    training: "Kurs",
    trainingForm: "Kursskjema",
    staffVouchers: "Kuponger",
    wholesalerVouchers: "Kuponger",
    brochure_prices: "Prislister og brosjyrer",
    investment: "Investeringsstotte",
    media: "Media",
    medias: "Media",
    wholesaler: "Grossistdashbord",
    contact_service: "Kontaktinformasjon og service",
    productInfo: "PRODUKTINFORMASJON",
    bDrive: "Produktbilder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Vilkår for deltaking",
    first_stop: "Bridgestone dekkgaranti",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Dashbord",
    accountDashboard: "Dashbord",
    account: "Profil",
    mailbox: "Innboks",
    singleMailbox: "Meldinger",
    stammdaten: "Stamdata",
    news_feeds: "Nyhetsstrømmer",
    pointsOverview: "Punktoversikt",
    rewardsOverview: "Punktoversikt",
    about: "Om BS Plus",
    service_number: "Kundeservice",
    shop: "Belønningsbutikk",
    salesPromotions: "Salgskampanjer",
    promotions: "Mi konto",
    shopCategory: "Belønningsbutikk",
    productDetails: "Produktdetaljer",
    userOrders: "Brukarbestillingar",
    shoppingCart: "Handlevogn",
    orderDelivery: "Leveringsadresse",
    orderSummary: "Ordreoversikt",
    orderComplete: "Bestilling fullført",
    staff: "Servicedashbord",
    onlineTrainings: "Nettkurs",
    trainings: "Kurs",
    training: "Kurs",
    trainingForm: "Kursskjema",
    staffVouchers: "Kuponger",
    wholesalerVouchers: "Kuponger",
    brochure_prices: "Prislister og brosjyrer",
    investment: "Investeringsstotte",
    media: "Media",
    medias: "Media",
    wholesaler: "Grossistdashbord",
    contact_service: "Kontaktinformasjon og service",
    productInfo: "PRODUKTINFORMASJON",
    bDrive: "Produktbilder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Vilkår for deltaking",
    first_stop: "Bridgestone dekkgaranti",
    payouts: "Payouts",
  },
  menu: {
    account: "Profil",
    plus: 'Om Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Salgsstøtte",
    mailbox: "Innboks",
    about: "Om BS Plus",
    trainingAndCourses: "Kurs og opplæring",
    externalTraining: "Ekstern opplæring",
    productInfo: "Produktinformasjon",
    productBrochures: "Produktbrosjyrer",
    priceLists: "Prislister",
    price: "Pris",
    complaintForm: "Klageskjema",
    sales_support: "Salgsstøtte",
    contact_service: "Kontaktinformasjon og service",
    logOut: "Logg ut",
    news: "Nyheter",
    news_feeds: "Nyhetsstrømmer",
    service_number: "Kundeservice",
    salesPromotions: "Salgskampanjer",
    shop: "Butikk",
    onlineTrainings: "Nettkurs",
    trainings: "Kurs",
    brochure_prices: "Prislister og brosjyrer",
    media: "Media",
    medias: "Media",
    stammdaten: "Stamdata",
    preislisten: "Prislister",
  },
  validation: {
    requiredField: "Feltet er påkravd",
  },
  sortBy: {
    default: "Sorter etter",
    desc: "Sorter etter: Nyeste",
    asc: "Sorter etter: Eldste",
    name: "Navn",
    date: "Dato",
    choiceBy: "Sorter",
  },
  month: {
    1: "Januar",
    2: "Februar",
    3: "Mars",
    4: "April",
    5: "Mai",
    6: "Juni",
    7: "Juli",
    8: "August",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "Desember",
  },
};


export default {
  messages,
};
